import React, { useEffect, useRef } from 'react';
import { Chessground } from 'chessground';
import { Chess } from 'chess.js';
// Chessground 9's package exports do not expose its bundled CSS.
import '../../node_modules/chessground/assets/chessground.base.css';
import '../../node_modules/chessground/assets/chessground.brown.css';
import '../../node_modules/chessground/assets/chessground.cburnett.css';

export function linePosition(line, moveIndex) {
  const game = new Chess();
  for (const move of line.moves.slice(0, moveIndex)) {
    game.move({ from: move.slice(0, 2), to: move.slice(2, 4), promotion: move[4] });
  }
  return game;
}

export default function OpeningBoard({ game, side, movableSide = side, disabled = true, hint, onMove }) {
  const element = useRef(null);
  const board = useRef(null);
  const configuration = useRef(null);
  const latestMove = useRef(onMove);
  latestMove.current = onMove;
  const fen = game.fen();
  useEffect(() => {
    board.current = Chessground(element.current, {
      animation: { enabled: true, duration: 180 },
      premovable: { enabled: false }, drawable: { enabled: false },
      movable: { free: false, rookCastle: false, events: { after: (from, to) => {
        // Restore position, turn, and legal destinations so rejected moves remain playable.
        board.current.set(configuration.current);
        latestMove.current?.(from, to);
      } } },
    });
    return () => board.current.destroy();
  }, []);
  useEffect(() => {
    const position = new Chess(fen);
    const destinations = new Map();
    if (!disabled) for (const move of position.moves({ verbose: true })) {
      destinations.set(move.from, [...(destinations.get(move.from) || []), move.to]);
    }
    configuration.current = {
      fen, orientation: side, turnColor: position.turn() === 'w' ? 'white' : 'black',
      check: position.isCheck(), movable: { color: disabled ? undefined : movableSide, dests: destinations },
      draggable: { enabled: !disabled }, selectable: { enabled: !disabled },
      drawable: { autoShapes: hint ? [{ orig: hint, brush: 'blue' }] : [] },
    };
    board.current.set(configuration.current);
  }, [fen, side, movableSide, disabled, hint]);
  return <div ref={element} className="opening-board [&_coords.files]:!bottom-0 [&_coords.files]:!left-0 [&_coords.files]:text-right [&_coords.files_coord]:pr-[3px] [&_coords.ranks]:!left-0 [&_coords.ranks]:!top-0 [&_coords.ranks_coord]:!transform-none [&_coords.ranks_coord]:pl-[3px]" role="img" aria-label={`Chessboard, ${side} at the bottom. ${disabled ? 'Preview position.' : 'Drag a piece or tap its start and destination squares.'}`} />;
}
